import DogFinisherBuilder from './DogFinisherBuilder'
import { IFinisherCodeBuilder as FinisherCodeBuilder } from './IFinisherCodeBuilder'
import RaceFinisherBuilder from './RaceFinisherBuilder'
import TrotFinisherBuilder from './TrotFinisherBuilder'

export default {
  from(starterType: string): FinisherCodeBuilder {
    switch (starterType) {
      case 'Races':
        return new RaceFinisherBuilder()
      case 'Dogs':
        return new DogFinisherBuilder()
      case 'Trots':
        return new TrotFinisherBuilder()
      default:
        throw new Error('invalid source.Type')
    }
  },
}
